import React from "react";

import "./Footer.css";

const footer = () => {
  return (
    <footer id="main-footer" className="text-center p-3">
      <div className="container">
        <div className="row">
          <div className="col">
            <p>Copyright 2018 &copy; AKCENTBUD</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default footer;



// WEBPACK FOOTER //
// ./src/components/Cloackroom/Footer/Footer.js